.container {
    display: flex;
    gap: 32px;
    padding: 32px;
    align-items: center;
}
